module.exports = __webpack_public_path__ + "492b3edd9de51e2f454c509430fa3c8e.svg";